import React, { useState, useEffect } from 'react';
import { getEmotions } from '../services/emotionService';
import { getColor } from '../utils/colorUtils';
import '../styles/TodayTempDisplay.scss';
import iconDate from '../assets/icon_date.svg';
import arrowIcon from '../assets/arrow.svg'; // Import the new arrow icon

const TodayTempDisplay: React.FC = () => {
  const [todayTemp, setTodayTemp] = useState<number | null>(null);
  const [currentDate, setCurrentDate] = useState<string>('');

  useEffect(() => {
    const fetchTodayTemp = async () => {
      try {
        const data = await getEmotions();
        const now = new Date();
        const todayFormatted = `${now.getFullYear()}-${(now.getMonth() + 1).toString().padStart(2, '0')}-${now.getDate().toString().padStart(2, '0')}`;
        setCurrentDate(todayFormatted);

        if (data && data.length > 0) {
          const lastRecordDate = new Date(data[0].createdAt).toDateString();
          const todayDate = new Date().toDateString();
          if (lastRecordDate === todayDate) {
            setTodayTemp(data[0].value);
          }
        }
      } catch (error) {
        console.error("Failed to fetch today's emotion:", error);
      }
    };

    fetchTodayTemp();
  }, []);

  const getComfortingMessage = (temp: number | null): string => {
    if (temp === null) return '오늘의 마음 온도를 기록해주세요.';
    // 38도 스케일 및 메시지 논리 수정
    if (temp < 8) return '스스로를 돌보는 시간이 필요해요. 무엇이 당신을 힘들게 하나요?';
    if (temp <= 15) return '마음이 조금 흐린 날이네요. 작은 위로가 큰 힘이 될 수 있어요.';
    if (temp <= 23) return '마음이 고요하지만 살짝 무겁군요. 따뜻한 차 한 잔이 어울리는 날이에요.';
    if (temp <= 30) return '오늘의 작은 행복들이 빛나는군요. 주변에 그 빛을 나눠주세요.';
    return '최고의 하루네요! 이 에너지를 내일에도 이어가 보세요.';
  };

  const getTempLabel = (temp: number | null): string => {
    if (temp === null) return '';
    if (temp >= 30) return '매우좋음';
    if (temp >= 23) return '좋음';
    if (temp >= 15) return '보통';
    if (temp >= 15) return '나쁨';
    return '매우나쁨';
  };

  const barStyle =
    todayTemp !== null
      ? {
          width: `${(todayTemp / 38) * 100}%`,
          background: getColor(todayTemp).gradient,
        }
      : {
          width: '0%',
          background: '#eee',
        };

  return (
    <div className="today-temp-display">
      <div className="display-header">
        <div className="header-left">
          <span className="calendar-icon">
            <img src={iconDate} alt="Date" />
          </span>
          <span className="current-date">{currentDate}</span>
        </div>
        <div className="header-right">
          {todayTemp !== null && (
            <span className="temp-badge">
              <span className="temp-label">{getTempLabel(todayTemp)}</span>
              {todayTemp}°
            </span>
          )}
        </div>
      </div>
      <h4 className="display-title">오늘의 마음 온도</h4>
      <p className="display-subtitle">오늘 당신의 마음 온도는 어떤가요?</p>
      <div className="temp-top-labels">
        <span>차가움</span>
        <span>따뜻함</span>
      </div>
      <div className="temp-bar-container">
        <div className="temp-bar" style={barStyle}>
          {todayTemp !== null && <span className="temp-value-on-bar">{todayTemp}°</span>}
        </div>
      </div>
      <div className="temp-labels">
        <span>0°</span>
        <span>10°</span>
        <span>20°</span>
        <span>30°</span>
        <span>38°</span>
      </div>
      <p className="comforting-message">
        <span className="message-icon">
          <img src={arrowIcon} alt="Arrow" />
        </span>
        {getComfortingMessage(todayTemp)}
      </p>
    </div>
  );
};

export default TodayTempDisplay;
